import { StorageObjectEventRetractReason } from '@navio/nsdk';

export const STORAGE_EVENT_RETRACT_REASON_LABEL: Record<StorageObjectEventRetractReason, string> = {
  [StorageObjectEventRetractReason.UNDONE_IN_HISTORY]: 'Undone in the storage history',
  [StorageObjectEventRetractReason.UNDONE_AFTER_SCAN]: 'Undone after scan',
  [StorageObjectEventRetractReason.INFERENCE_CONTRADICTED]: 'Corrected by a later scan'
};

type LatestMoveEvent = { isRetractable: boolean; createdBy?: { id: number } | null };

export const canUndoLastMove = (latestEvent: LatestMoveEvent | null | undefined, userId: number | undefined): boolean =>
  latestEvent != null && latestEvent.isRetractable && userId != null && latestEvent.createdBy?.id === userId;
